export default __webpack_public_path__ + "static/Hour-Glass-bbee5bd49e89e332a58ff10877e16525.png";